import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';

const testimonials = [
  {
    id: 1,
    name: '小雅',
    role: '职场白领 · 32岁',
    content: '通过催眠疗愈，我终于解开了多年来的亲密关系困扰。以前总是不自觉地在关系中退缩，现在我能坦然面对自己的情感，和伴侣的关系比以前更加亲密和和谐了。非常感谢催眠性福生活的专业指导！',
    rating: 5,
  },
  {
    id: 2,
    name: '志强',
    role: '企业管理者 · 38岁',
    content: '工作压力大导致我长期失眠和焦虑，影响了和妻子的亲密关系。催眠放松技巧让我找到了内心的平静，睡眠质量明显改善，现在和家人的关系也更加融洽了。催眠真的改变了我的生活。',
    rating: 5,
  },
  {
    id: 3,
    name: '丽华',
    role: '全职妈妈 · 35岁',
    content: '生完孩子后，我对自己的身体非常不自信，严重影响了和丈夫的亲密关系。催眠疗愈帮助我重建了积极的身体意象，让我重新找回了作为女性的自信和魅力。这是我送给自己最好的礼物。',
    rating: 5,
  },
  {
    id: 4,
    name: '伟豪',
    role: '自由职业者 · 29岁',
    content: '自我催眠入门指南中的技巧非常实用！我按照步骤练习了两周，就明显感觉到压力水平下降了，和女朋友的沟通也变得更加顺畅。最棒的是，这些技巧随时随地都能用。',
    rating: 5,
  },
  {
    id: 5,
    name: '婉婷',
    role: '教师 · 41岁',
    content: '经历了情感创伤后一直走不出来，直到朋友推荐了催眠疗愈。在专业催眠治疗师的帮助下，我终于和过去的伤痛和解了。现在的我，内心充满了平静和力量，对未来的感情生活也重新燃起了希望。',
    rating: 5,
  },
  {
    id: 6,
    name: '明辉',
    role: '医生 · 36岁',
    content: '作为一名医生，我起初对催眠持怀疑态度。但亲身体验后，我对催眠的科学性和有效性有了全新的认识。催眠帮助我更好地管理压力、提升专注力，也让我在亲密关系中更加懂得如何表达和倾听。',
    rating: 5,
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();

    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9q9shnnahb7382ov8e0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || '提交失败，请稍后重试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后重试');
          setFormStatus('error');
        } else {
          setFormError(serverMsg);
          setFormStatus('error');
        }
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ];

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 催眠性福生活',
    description: '催眠性福生活是一个专注于催眠疗愈与亲密关系幸福的专业内容平台，致力于传播科学的催眠知识，帮助人们改善亲密关系质量和生活幸福感。',
    url: 'https://www.cuimianxingfu.com/about',
    inLanguage: 'zh-Hans',
    isPartOf: {
      '@type': 'WebSite',
      name: '催眠性福生活',
      url: 'https://www.cuimianxingfu.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg data={aboutSchema} />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 md:pt-24">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            {/* Breadcrumb */}
            <div className="py-4">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            {/* Page Header */}
            <div className="py-6 md:py-8 text-center">
              <h1 className="text-xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
                关于我们
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
                用专业和真诚，为每一位追求幸福的人提供科学的催眠知识与温暖的陪伴
              </p>
            </div>

            {/* Brand Introduction */}
            <section className="py-8 md:py-10">
              <div className="flex flex-col lg:flex-row gap-8 md:gap-10 items-center">
                <div className="flex-1">
                  <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                    品牌介绍
                  </h2>
                  <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                    <p>
                      <strong>催眠性福生活</strong>成立于2020年，是一个专注于催眠疗愈与亲密关系幸福的综合性内容平台。我们汇聚了一批经验丰富的专业催眠治疗师、心理咨询师和情感导师，致力于用科学、专业、温暖的方式，帮助每一个追求幸福的人释放心理障碍，提升亲密关系质量，增强身心愉悦感。
                    </p>
                    <p>
                      我们相信，催眠不是神秘的超自然力量，而是一种经过现代神经科学验证的心理治疗工具。通过深入潜意识，我们可以松动那些限制性的信念，释放被压抑的情感，唤醒内在的自愈力量。无论是改善亲密关系、缓解焦虑压力，还是提升生活幸福感，催眠都能提供独特而有效的帮助。
                    </p>
                    <p>
                      我们的使命是让更多人了解催眠的科学性和实用性，消除对催眠的误解和恐惧，让这项强大的心理技术惠及每一个需要它的人。我们提供高质量的文章、实用的自我催眠技巧、以及专业的催眠疗愈资源，陪伴你在追求幸福的道路上稳步前行。
                    </p>
                  </div>
                </div>
                <div className="flex-1 w-full">
                  <div className="rounded-lg overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Warm%20cozy%20therapy%20room%20with%20soft%20natural%20lighting%2C%20comfortable%20armchair%2C%20gentle%20cream%20and%20beige%20interior%2C%20healing%20and%20peaceful%20atmosphere%2C%20professional%20yet%20inviting%20setting%2C%20editorial%20interior%20photography&width=800&height=600&seq=about-brand-2026&orientation=landscape"
                      alt="催眠性福生活 - 专业的催眠疗愈空间"
                      className="w-full h-auto object-cover"
                    />
                  </div>
                </div>
              </div>
            </section>

            {/* Core Values */}
            <section className="py-8 md:py-10">
              <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
                我们的核心价值
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
                {[
                  {
                    icon: 'ri-shield-star-line',
                    title: '科学专业',
                    desc: '所有内容均基于现代心理学和神经科学研究，由持证催眠治疗师和心理咨询师审核把关，确保信息的准确性和专业性。',
                  },
                  {
                    icon: 'ri-heart-add-line',
                    title: '真诚温暖',
                    desc: '我们理解每个人在情感和亲密关系中的脆弱与渴望，用真诚的文字和温暖的陪伴，为你创造一个安全、接纳的成长空间。',
                  },
                  {
                    icon: 'ri-lightbulb-flash-line',
                    title: '实用有效',
                    desc: '不只讲理论，更提供可操作的练习方法。每一篇文章、每一个技巧都经过实践验证，确保你能真正学以致用。',
                  },
                ].map((value, i) => (
                  <div
                    key={i}
                    className="p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/70"
                  >
                    <div className="w-12 h-12 mb-3 flex items-center justify-center bg-primary-100 rounded-full">
                      <i className={`${value.icon} text-xl text-primary-600`}></i>
                    </div>
                    <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">
                      {value.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {value.desc}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* Testimonials */}
            <section className="py-8 md:py-10">
              <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-6 md:mb-8">
                来自真实用户的反馈，他们的改变是我们最大的动力
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {testimonials.map((t) => (
                  <div
                    key={t.id}
                    className="p-5 bg-background-100 rounded-lg border border-background-200/70"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm text-primary-500"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      {t.content}
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                        <span className="text-xs font-semibold text-secondary-700">
                          {t.name.charAt(0)}
                        </span>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact Section */}
            <section className="py-8 md:py-10">
              <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
                <div className="flex-1">
                  <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                    联系我们
                  </h2>
                  <p className="text-sm text-foreground-500 mb-6">
                    如果你有任何关于催眠疗愈的问题，或希望了解更多信息，欢迎随时与我们联系。我们的团队会在24小时内回复你的消息。
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-full">
                        <i className="ri-mail-line text-lg text-primary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800">电子邮箱</h4>
                        <p className="text-sm text-foreground-500">contact@cuimianxingfu.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-full">
                        <i className="ri-phone-line text-lg text-primary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800">咨询热线</h4>
                        <p className="text-sm text-foreground-500">400-888-9999</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-full">
                        <i className="ri-map-pin-line text-lg text-primary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800">办公地址</h4>
                        <p className="text-sm text-foreground-500">北京市朝阳区建国路88号SOHO现代城A座12层</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <div className="bg-background-100 rounded-lg border border-background-200/70 p-5 md:p-6">
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-4">
                      发送消息
                    </h3>
                    <form
                      data-readdy-form="true"
                      onSubmit={handleSubmit}
                      className="space-y-4"
                    >
                      <div>
                        <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          姓名 <span className="text-accent-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="about-name"
                          name="name"
                          required
                          className="w-full px-3 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          电子邮箱 <span className="text-accent-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="about-email"
                          name="email"
                          required
                          className="w-full px-3 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors"
                          placeholder="请输入您的电子邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          留言内容 <span className="text-accent-500">*</span>
                        </label>
                        <textarea
                          id="about-message"
                          name="message"
                          required
                          maxLength={500}
                          rows={4}
                          className="w-full px-3 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                          placeholder="请输入您的留言（限500字）"
                        ></textarea>
                      </div>
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                        className="anti-spam-hp"
                      />
                      <button
                        type="submit"
                        className="w-full px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
                      >
                        发送消息
                      </button>

                      {formStatus === 'success' && (
                        <p className="text-sm text-green-600 text-center">
                          消息已成功发送！我们会在24小时内回复您。
                        </p>
                      )}
                      {formStatus === 'error' && (
                        <p className="text-sm text-red-600 text-center">
                          {formError}
                        </p>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}